import './NoteItemForm.css';

import React, { useEffect, useState } from 'react';
import B2BFormContainer from '../../../b2b-common/B2BFormContainer';
import { useLoginContext } from '../../../../App';
import { useContentContext } from '../../../layout/Layout';
import EditText from '../../../b2b-common/EditText';
import FieldComponent from '../../../b2b-common/FieldComponent';
import BooleanIconToggle from '../../../b2b-common/BooleanIconToggle';
import { Star, StarBorder } from '@mui/icons-material';
import RichNoteEditor from './RichNoteEditor';
import { showNotification } from '../../../b2b-common/Notification';
import { createItem, updateItem } from '../../../../services/b2b-logbook-apiServices';
import useB2BTranslation from '../../../b2b-common/hooks/useB2BTranslation';

const NoteItemForm = ({ logbook, itemNote = null, folder, onClose, onSaved }) => {
    const { loginData } = useLoginContext();
    const { setNotification } = useContentContext();
    const { t } = useB2BTranslation('b2b-logbook');

    const blankNote = {
        logBookItemType: 'NOTE',
        logBookId: logbook.logBookId,
        logBookFolderId: folder ? folder.logBookFolderId : 0,
        logBookItemId: 0,
        // logBook: logbook,
        // logBookFolder: folder ?? {},
        logBookItemCreationTime: new Date().toISOString(), // Converting to ISO string for LocalDateTime
        logBookItemName: `${t('New Note')}`,
        logBookItemDescription: '',
        logBookItemStarred: false,
        logBookItemNoteText: ''
    }

    const [currentNote, setCurrentNote] = useState(itemNote || blankNote);

    useEffect(() => {
        if (itemNote) {
            setCurrentNote(itemNote);
        }
    }, [itemNote]);

    useEffect(() => {
        if (folder && (folder.logBookFolderId !== currentNote.logBookFolderId)) {
            setCurrentNote({ ...currentNote, logBookFolderId: folder.logBookFolderId });
        }
    }, [folder]);

    const handleSave = async () => {
        if (itemNote === null) { // Create
            try {
                const updatedItem = await createItem(loginData.accessToken, currentNote.logBookId, currentNote.logBookFolderId, currentNote);
                showNotification(setNotification, t('Note created successfully.'), 'success', 3000);
                onSaved && onSaved(updatedItem);
            } catch (error) {
                console.error('Error creating note:', error);
                showNotification(setNotification, t('Error creating note: ') + error.message, 'error', 5000);
            }
        } else { // Update
            try {
                const updatedItem = await updateItem(loginData.accessToken, currentNote.logBookId, currentNote.logBookFolderId, currentNote.logBookItemId, currentNote);
                showNotification(setNotification, t('Note updated successfully.'), 'success', 3000);
                onSaved && onSaved(updatedItem);
            } catch (error) {
                console.error('Error updating note:', error);
                showNotification(setNotification, t('Error updating note: ') + error.message, 'error', 5000);
            }
        }
    }

    return (
        <B2BFormContainer title={itemNote ? t('Edit Note') : t('New Note')} onClose={onClose} onSave={handleSave}
            showDivider={false}
            buttonsConfig={[
                { label: t('Save'), onClick: handleSave },
            ]}
            className='note-item-form'>

            <div>
                <EditText object={currentNote} objectField='logBookItemName' setObjectField={setCurrentNote} label={t('Note Name')} />
                <FieldComponent label={t('Favorite')} className={'note-item-starred-toggle'}
                    component={
                        <BooleanIconToggle
                            value={currentNote.logBookItemStarred}
                            trueIcon={<Star />}
                            falseIcon={<StarBorder />}
                            onChange={(value) => setCurrentNote({ ...currentNote, logBookItemStarred: value })}
                        />
                    }
                />
            </div>
            <EditText object={currentNote} objectField='logBookItemDescription' setObjectField={setCurrentNote} label={t('Description')} multiline={true} rows={3} />
            <RichNoteEditor
                value={currentNote.logBookItemNoteText}
                onChange={(content) => setCurrentNote({ ...currentNote, logBookItemNoteText: content })}
            />
        </B2BFormContainer>
    );
}

export default NoteItemForm;